import { Component, Input, ViewChild, ViewContainerRef, ComponentRef, ComponentFactoryResolver, Compiler, ChangeDetectorRef, Type } from '@angular/core';

import { C16Component } from '../client/c16/c16.component';
import { C12Component } from '../client/c12/c12.component';

@Component({
  selector: 'special-client',
  template: '<div #specialView></div>'
})
export class SpecialClientComponent {
  @ViewChild('specialView', {read: ViewContainerRef}) specialView: ViewContainerRef;
  @Input() clientId:number;
  @Input() formId:number;

  private type: Type<Component>;
  cmpRef: ComponentRef<Component>;
  private isViewInitialized:boolean = false;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private compiler: Compiler, private cdRef:ChangeDetectorRef) { }

  updateComponent() {
    if(!this.isViewInitialized) {
      return;
    }
    if(this.cmpRef) {
      this.cmpRef.destroy();
    }

    switch (this.clientId) {
      case 16:
        switch (this.formId) {
          default:
            this.type = C16Component;
        }
        break;
      case 12:
        switch (this.formId) {
          default:
            this.type = C12Component;
        }
        break;
      default:
    }

    let factory = this.componentFactoryResolver.resolveComponentFactory(this.type);
    this.cmpRef = this.specialView.createComponent(factory);
    // to access the created instance use
    // this.compRef.instance.someProperty = 'someValue';
    // this.compRef.instance.someOutput.subscribe(val => doSomething());
    this.cdRef.detectChanges();
  }

  ngOnChanges() {
    this.updateComponent();
  }

  ngAfterViewInit() {
    this.isViewInitialized = true;
    this.updateComponent();
  }

  ngOnDestroy() {
    if(this.cmpRef) {
      this.cmpRef.destroy();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/special-client/special-client.component.ts